export default __webpack_public_path__ + "static/media/image-1.445eab9f.jpeg";